fragment ProductFeatureThreeFragment on productFeatureThree_Entry {
  typeHandle
  mainHeading
  mainCta {
    ...LinkFragment
    ... on HyperLinkInterface {
      element {
        ... on products_Entry {
          sectionHandle
          shopifyHandle
        }
      }
    }
  }
  mainImage {
    url
    title
  }
  mainImageAlt

  secondaryHeading
  secondaryImage {
    url
  }
  secondaryAlt

  tertiaryHeading
  tertinaryCta {
    ...LinkFragment
  }
}
